import React from "react"

import styles from "./styles.module.scss"
import classNames from "classnames";

export const headingAndTextarea = [
	{
		id: 0,
		heading: "Сотрудникам зала",
		headingType: "secondary",
		textarea: (
			<>
				<span className={styles.tablet}>
					Интуитивно понятный интерфейс Quick Resto ускоряет работу.
					<br />
					Всё быстро — от рассадки гостей до техкарт на кухонном дисплее.
				</span>
				<span className={styles.mobile}>
					Интуитивно понятный интерфейс
					<br />
					Quick Resto ускоряет работу.
					<br />
					Всё быстро — от рассадки гостей
					<br />
					до техкарт на кухонном дисплее.
				</span>
			</>
		),
	},
	{
		id: 1,
		heading: "Гостям заведения",
		headingType: "secondary",
		textarea: (
			<>
				<span className={styles.tablet}>
					Сделай своё заведение запоминающимся с помощью мобильного приложения,
					<br />
					сайта и бонусной программы с картами лояльности.
				</span>
				<span className={styles.mobile}>
					Сделай своё заведение запоминающимся
					<br />
					с помощью мобильного приложения,
					<br />
					сайта и бонусной программы
					<br />с картами лояльности.
				</span>
			</>
		),
	},
	{
		id: 2,
		heading: "Сотрудникам бэк-офиса",
		headingType: "secondary",
		textarea: (
			<>
				<span className={classNames(styles.tablet, styles.text)}>
					QuickResto – это гибкая система автоматизации для развития бизнеса.
					<br />
					Экосистемное решение — от мобильного приложения для гостей до
					управления персоналом.
				</span>
				<span className={styles.mobile}>
					QuickResto – это гибкая система
					<br />
					автоматизации для развития бизнеса.
					<br />
					Экосистемное решение — от мобильного
					<br />
					приложения для гостей до управления
					<br />
					персоналом.
				</span>
			</>
		),
	},
	{
		id: 3,
		heading: "Руководителям",
		headingType: "secondary",
		textarea: (
			<>
				<span className={styles.tablet}>
					Управляй своим бизнесом из любой точки.
					<br />
					Решения QuickResto обеспечивают полную прозрачность процессов.
				</span>
				<span className={styles.mobile}>
					Управляй своим бизнесом
					<br />
					из любой точки.
					<br />
					Решения QuickResto обеспечивают
					<br />
					полную прозрачность процессов.
				</span>
			</>
		),
	},
]
